module.exports = __webpack_public_path__ + "img/simulationTab.9555e153.gif";